export var E_Switch;
(function (E_Switch) {
    E_Switch["On"] = "on";
    E_Switch["Off"] = "off";
})(E_Switch || (E_Switch = {}));
